import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useFormContext } from "react-hook-form";

import ChooseTemplateConstruction from "../ChooseTemplateConstruction";
import TemplateExamplesChipMenu from "../ExamplesChipMenu";
import FileUploader from "../FileUploader";
import PreferencesSection from "../PreferencesSection";
import TemplateFields from "../TemplateFields";

const FormBuilderSection = ({
  control,
  setShowResetTemplateConstructionModal,
  openConfirmationOpenIfFieldsFilled,
  setShowConfirmTemplateConstructionModal,
  templateConstructionChoice,
  setTemplateConstructionChoice,
  handleHighlightClick,
  handleFileChange,
  highlightFileUploader,
  loadingExtraction,
  handleClearInspirationChips,
}) => {
  const { watch } = useFormContext(control);
  const formData = watch();

  return (
    <div className="flex flex-col space-y-8">
      <div
        id="template-structure"
        className="bg-gray-50 dark:bg-gray-700/50 border border-gray-100 dark:border-gray-700 rounded-xl p-4"
      >
        {templateConstructionChoice === "scratch" && (
          <div className="mb-4">
            <TemplateExamplesChipMenu
              templateType={formData?.templateType}
              handleClearInspirationChips={
                handleClearInspirationChips
              }
            />
          </div>
        )}
        <ChooseTemplateConstruction
          setShowResetTemplateConstructionModal={
            setShowResetTemplateConstructionModal
          }
          openConfirmationOpenIfFieldsFilled={
            openConfirmationOpenIfFieldsFilled
          }
          setShowConfirmTemplateConstructionModal={
            setShowConfirmTemplateConstructionModal
          }
          selectedChoice={templateConstructionChoice}
          onSelect={setTemplateConstructionChoice}
          handleHighlightClick={handleHighlightClick}
        />

        {templateConstructionChoice === "upload" &&
          loadingExtraction && (
            <div className="text-center my-4 flex flex-col items-center gap-2 border-2 border-dashed rounded-xl p-4 border-indigo-300 dark:border-indigo-300 dark:hover:border-indigo-300 hover:border-indigo-300">
              <span>Extracting the text from your PDF...</span>
              <FontAwesomeIcon
                icon={faSpinner}
                size="2x"
                className="animate-spin text-indigo-500"
              />
            </div>
          )}
        {templateConstructionChoice === "upload" &&
          !loadingExtraction && (
            <FileUploader
              handleFileChange={handleFileChange}
              highlightFileUploader={highlightFileUploader}
            />
          )}

        {(templateConstructionChoice === "scratch" ||
          templateConstructionChoice === "upload") && (
          <TemplateFields control={control} />
        )}
      </div>

      <div
        id="template-preferences"
        className="bg-gray-50 dark:bg-gray-700/50 border border-gray-100 dark:border-gray-700 rounded-xl p-4"
      >
        <PreferencesSection control={control} />
      </div>
    </div>
  );
};

export default FormBuilderSection;
